'use strict'

var Marionette = require('marionette')
var App = require('app')

var TimelineComponent = require('src/components/timeline-view')

/**
 * Layout
 * -----------------------------------------------------------------------------
 */
var Layout = Marionette.View.extend({
  template: require('./templates/layout.html'),
  regions: {
    scheduleRegion: '.schedule-region'
  },
  triggers: {
    'click .js-add': 'schedule:add',
    'click .js-next': 'timeline:next'
  },
  templateContext: function () {
    return {
      getLastSeenAt: App.TemplateHelpers.getLastSeenAt,
      userHasRole: App.TemplateHelpers.userHasRole,
      getConditionalStr: App.TemplateHelpers.getConditionalStr
    }
  }
})

module.exports.Layout = Layout

/**
 * Timeline list item view
 * -----------------------------------------------------------------------------
 */
var TimelineListItemView = TimelineComponent.TimelineListItemView.extend({
  template: require('./templates/timeline-list-item.html')
})

/**
 * Timeline collection view
 * -----------------------------------------------------------------------------
 */
var TimelineCollectionView = TimelineComponent.TimelineCollectionView.extend({
  childView: TimelineListItemView
})

/**
 * Timeline layout view
 * -----------------------------------------------------------------------------
 */
var TimelineLayoutView = TimelineComponent.TimelineLayoutView.extend({
  childView: TimelineCollectionView
})

module.exports.TimelineView = TimelineLayoutView



// WEBPACK FOOTER //
// ./js/modules/schedules/list/view.js